/*
 * Copyright (c) 2021.
 * 2iPartners SàRL and/or its affiliates.
 * All rights reserved.
 *
 * 2iPartners SàRL
 * Route de Compois 24,
 * 1252 Meinier
 * Suisse
 *
 * tel : +41 22 735 97 07
 */

export class ToolsHelper {

  static hardCopy(it: any): any {
    return JSON.parse(JSON.stringify(it));
  }

  static getId(it: any): number | null {
    return it && it.id ? Number(it) : null;
  }

  static isUndefinedOrNull(it: any): boolean {
    return null === it || 'undefined' === typeof it;
  }

  static isValidAnimalNumber(it: any): boolean {
    return !ToolsHelper.isUndefinedOrNull(it) && 'string' === typeof it && '' !== it;
  }

  static isNumber(it: any): boolean {
    return !ToolsHelper.isUndefinedOrNull(it) && !isNaN(Number(it));
  }

  static now(): number {
    return Math.round(new Date().getTime() / 1000);
  }

}
